import { vsName as DepreciationComponentName } from "./component";
import { vsComponentName as DepreciationEditComponentName } from "./DepreciationEdit/component";
import {
  vsProviderName as machineDetailTabsProviderName,
  MachineDetailTabsProvider,
} from "../../../../machines/shared/components/views/machines/detail/tabs";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../records/server/serverUtility";
import { Machine } from "../../../../machines/shared/models/machine";
import { ServiceResponse } from "../../../../records/server/query";
import { MachineConfiguration } from "../../../../machines/shared/models/machineConfiguration";

export function machineDetailDepreciationComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addElement({
    id: "Depreciation",
    displayName: "Depreciation",
    uiSrefFragment: "Depreciation",
    requiredPermission: "machineView",
    stateDefinition: {
      component: DepreciationComponentName,
      url: "/Depreciation",
      resolve: {
        machine: ["machine", (machine: any) => machine],
        depreciation: [
          serverUtilityName,
          "machine",
          function (serverUtility: ServerUtility, machine: Machine<MachineConfiguration>) {
            const machineId = machine.Id;
            return serverUtility
              .sendApiRequest({
                method: "get",
                url: `api/machines/Machine/${machineId}/depreciation`,
              })
              .then((r) => (<ServiceResponse<unknown>>r).Result);
          },
        ],
      },
      bindings: {
        machine: "machine",
      },
    },
    children: [
      {
        id: "edit",
        displayName: "Edit",
        uiSrefFragment: "edit",
        stateDefinition: {
          component: DepreciationEditComponentName,
          url: "/edit",
          resolve: {
            returnSubmitState: [() => "^"],
            returnCancelState: [() => "^"],
            machine: ["machine", (machine: any) => machine],
            defaultSetting: [
              serverUtilityName,
              function (serverUtility: ServerUtility) {
                return serverUtility
                  .sendApiRequest({
                    method: "get",
                    url: "/api/machines/depreciation/defaultSettings",
                  })
                  .then((r) => (<ServiceResponse<unknown>>r).Result);
              },
            ],
            depreciation: [
              serverUtilityName,
              "machine",
              function (serverUtility: ServerUtility, machine: Machine<MachineConfiguration>) {
                const machineId = machine.Id;
                return serverUtility
                  .sendApiRequest({
                    method: "get",
                    url: `api/machines/Machine/${machineId}/depreciation`,
                  })
                  .then((r) => (<ServiceResponse<unknown>>r).Result);
              },
            ],
          },
          bindings: {
            machine: "machine",
          },
        },
      },
    ],
  });
}

machineDetailDepreciationComponentConfig.$inject = [
  machineDetailTabsProviderName,
];
